<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { RouterLink } from 'vue-router'
import ArrowIcon from '@/components/shared/ArrowIcon.vue'
import organizerPublicWebsiteImage from '@/assets/marketing/organizer-public-website.png'

const { t } = useI18n()
</script>

<template>
  <section class="relative bg-slate-900 py-24 overflow-hidden">
    <div
      class="absolute inset-0 pointer-events-none"
      style="background: radial-gradient(ellipse 70% 50% at 50% 50%, rgba(16,185,129,0.14) 0%, transparent 70%);"
    ></div>

    <div class="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
      <p class="text-emerald-400 font-semibold text-sm uppercase tracking-widest">
        {{ t('organizers_lp.website.label') }}
      </p>
      <h2 class="text-3xl md:text-5xl font-black text-white mt-4 leading-tight">
        {{ t('organizers_lp.website.heading') }}
      </h2>
      <p class="text-slate-400 mt-6 text-lg max-w-2xl mx-auto leading-relaxed">
        {{ t('organizers_lp.website.body') }}
      </p>

      <!-- Faux browser chrome -->
      <div class="mt-12 rounded-xl overflow-hidden border border-slate-700 shadow-2xl max-w-2xl mx-auto">
        <div class="bg-slate-800 px-4 py-3 flex items-center gap-3">
          <div class="flex items-center gap-1.5">
            <span class="w-3 h-3 rounded-full bg-red-500/70"></span>
            <span class="w-3 h-3 rounded-full bg-amber-500/70"></span>
            <span class="w-3 h-3 rounded-full bg-emerald-500/70"></span>
          </div>
          <div class="flex-1 bg-slate-700 rounded-md px-3 py-1 text-xs text-slate-400 text-left font-mono">
            {{ t('organizers_lp.website.url_label') }}
          </div>
        </div>
        <div class="bg-slate-800/50 aspect-video flex items-center justify-center border-t border-slate-700/50">
          <img :src="organizerPublicWebsiteImage" alt="Organizer Public Website" class="border border-slate-200 shadow-xl w-full" />
        </div>
      </div>

      <ul class="mt-10 flex flex-col sm:flex-row flex-wrap justify-center gap-4 text-sm text-slate-400">
        <li class="flex items-center gap-2">
          <span class="text-emerald-500">✓</span> {{ t('organizers_lp.website.feature1') }}
        </li>
        <li class="flex items-center gap-2">
          <span class="text-emerald-500">✓</span> {{ t('organizers_lp.website.feature2') }}
        </li>
        <li class="flex items-center gap-2">
          <span class="text-emerald-500">✓</span> {{ t('organizers_lp.website.feature3') }}
        </li>
      </ul>

      <RouterLink
        to="/organizer/onboarding"
        class="inline-flex items-center gap-2 mt-10 bg-emerald-500 hover:bg-emerald-400 text-white font-semibold rounded-lg px-8 py-4 text-base transition-colors"
      >
        {{ t('organizers_lp.website.cta') }}
        <ArrowIcon direction="right" class="w-4 h-4" />
      </RouterLink>
    </div>
  </section>
</template>
